/**
 * Copyright Motili Inc., 2016 All Rights Reserved
 */

import { Component } from 'react';
import PropTypes from 'prop-types';
import Alert from 'common/components/Alert';

import { LoadingSpinner } from '@motili/ui';
import * as logger from '../../utils/Logger';
import Config from '../../../Config';

import './style/sass/layout.scss';

/**
 * Base Content Container
 */
export default class Content extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
        this.showError = this.showError.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        this.showError(error, errorInfo);
    }

    showError(error, errorInfo) {
        logger.error({ ...error, errorInfo });
        this.setState({ hasError: true }, () => {
            Alert.error(`An unexpected error occurred: ${error.message}`);
        });
    }

    render() {
        return (
            <div className='motili-content'>
                {this.state.hasError && (
                    <div style={styles.errorMessageContainer}>
                        <span style={styles.pageLoadErrorIcon}>
                            This page failed to load, please let us know!&nbsp;
                        </span>
                    </div>
                )}
                {this.props.loading && !this.state.hasError && (
                    <LoadingSpinner />
                )}
                {!this.props.loading &&
                    !this.state.hasError &&
                    this.props.children}
            </div>
        );
    }
}

const styles = {
    errorMessageContainer: {
        height: '100%',
        paddingTop: '25%',
    },
    pageLoadErrorIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '32px',
        color: Config.color.red,
    },
};

Content.propTypes = {
    loading: PropTypes.bool,
    children: PropTypes.node,
};
